(function () {
  var INVERSE_CLASS = 'parent_li_inverse';
  var PANEL_GAP = 20;
  var EDGE_GAP = 16;

  var getPanels = function (item) {
    var child = item.querySelector(':scope > ul.child_wrapper');
    if (!child) return null;

    var widest = 0;
    child.querySelectorAll('ul.grandchild_wrapper').forEach(function (panel) {
      if (panel.offsetWidth > widest) widest = panel.offsetWidth;
    });

    return { child: child, grandchildWidth: widest };
  };

  var updateItem = function (item) {
    if (item.classList.contains('is_mega_menu')) return;
    if (!item.offsetParent) return;

    var panels = getPanels(item);
    if (!panels) return;

    var wasInverse = item.classList.contains(INVERSE_CLASS);
    item.classList.remove(INVERSE_CLASS);

    var rect = item.getBoundingClientRect();
    var width = panels.child.offsetWidth;
    if (panels.grandchildWidth) width += panels.grandchildWidth + PANEL_GAP;

    if (!width) {
      if (wasInverse) item.classList.add(INVERSE_CLASS);
      return;
    }

    var fitsRight = rect.left + width + EDGE_GAP <= window.innerWidth;
    if (fitsRight) return;

    var fitsLeft = rect.right - width - EDGE_GAP >= 0;
    var spaceRight = window.innerWidth - rect.left;
    var spaceLeft = rect.right;

    if (fitsLeft || spaceLeft > spaceRight) item.classList.add(INVERSE_CLASS);
  };

  var updateAll = function () {
    document.querySelectorAll('.header_navigation_inner .parent_li').forEach(updateItem);
  };

  var ticking = false;
  var scheduleUpdate = function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      updateAll();
      ticking = false;
    });
  };

  var bind = function () {
    document.querySelectorAll('.header_navigation_inner .parent_li').forEach(function (item) {
      if (item.dataset.navFlipBound === 'true') return;
      item.dataset.navFlipBound = 'true';
      item.addEventListener('pointerenter', function () {
        updateItem(item);
      });
      item.addEventListener('focusin', function () {
        updateItem(item);
      });
    });
  };

  var init = function () {
    bind();
    updateAll();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', scheduleUpdate, { passive: true });
  window.addEventListener('load', scheduleUpdate);
  document.addEventListener('shopify:section:load', init);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(scheduleUpdate);
  }
})();
